import React from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
interface Course {
  id: number;
  title: string;
  icon: string;
  description: string;
  color: string;
  image?: string;
}
const courses: Course[] = [{
  id: 1,
  title: 'Spagat School',
  icon: '🤸',
  description: 'Erlerne den Spagat Schritt für Schritt mit gezieltem Stretching.',
  color: 'from-peony-400 to-peony-600',
  image: 'https://images.unsplash.com/photo-1518611012118-696072aa579a?w=800&q=80'
}, {
  id: 2,
  title: 'Aerial Stretching',
  icon: '🎪',
  description: 'Schwebende Dehnübungen am Tuch für maximale Flexibilität.',
  color: 'from-purple-500 to-purple-800',
  image: 'https://cdn.magicpatterns.com/uploads/evFTBYFGe2NJJ884cFhNGg/IMG_5987.JPG.webp'
}, {
  id: 3,
  title: 'Gesunder Rücken',
  icon: '💆',
  description: 'Stärke deinen Rücken und befreie dich von Verspannungen.',
  color: 'from-teal-400 to-teal-600',
  image: 'https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?w=800&q=80'
}, {
  id: 4,
  title: 'Functional Training',
  icon: '💪',
  description: 'Ganzheitliches Training für Kraft, Ausdauer und Beweglichkeit.',
  color: 'from-orange-400 to-orange-700',
  image: 'https://cdn.magicpatterns.com/uploads/d6oTQ5gxpwQYjLS4Nso4DC/IMG_5949.JPG.webp'
}, {
  id: 5,
  title: 'Tanz Dich Frei',
  icon: '💃',
  description: 'Tanz-Fitness für Körper und Seele – keine Vorkenntnisse nötig.',
  color: 'from-pink-400 to-pink-600',
  image: 'https://images.unsplash.com/photo-1508700115892-45ecd05ae2ad?w=800&q=80'
}, {
  id: 6,
  title: 'Backbend School',
  icon: '🌙',
  description: 'Öffne deine Brust und Wirbelsäule mit eleganten Rückbeugen.',
  color: 'from-indigo-400 to-indigo-600',
  image: 'https://images.unsplash.com/photo-1599901860904-17e6ed7083a0?w=800&q=80'
}];
export function Courses() {
  const {
    ref,
    isVisible
  } = useScrollAnimation();
  return <section id="courses" className="py-24 bg-white" data-id="element-26">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-27">
        <div className="text-center mb-16" data-id="element-28">
          <h2 className="text-4xl md:text-5xl font-bold text-dark-studio mb-4" data-id="element-29">
            Unsere Kurse
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-30">
            Entdecke unser vielfältiges Angebot für mehr Flexibilität und Kraft.
          </p>
        </div>

        <div ref={ref} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-31">
          {courses.map((course, index) => <div key={course.id} className={`group relative h-80 rounded-2xl overflow-hidden cursor-pointer transition-all duration-500 transform hover:-translate-y-2 hover:shadow-2xl ${isVisible ? 'animate-fade-in-up' : 'opacity-0'}`} style={{
          animationDelay: `${index * 100}ms`
        }} data-id="element-32">
              {/* Background: photo if available, else gradient */}
              {course.image ? <>
                  <img src={course.image} alt={course.title} className="absolute inset-0 w-full h-full object-cover object-center transition-transform duration-500 group-hover:scale-105" data-id="element-33" />
                  {/* Dark overlay so default content is readable */}
                  <div className={`absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-black/10 transition-opacity duration-300`} data-id="element-34"></div>
                </> : <div className={`absolute inset-0 bg-gradient-to-br ${course.color} opacity-90`} data-id="element-35"></div>}

              {/* Default Content */}
              <div className="absolute inset-0 flex flex-col items-center justify-center p-6 text-center transition-all duration-300 group-hover:opacity-0 group-hover:scale-90" data-id="element-36">
                <h3 className="text-2xl font-bold text-white tracking-wide drop-shadow-md" data-id="element-37">
                  {course.title}
                </h3>
              </div>

              {/* Hover Content */}
              <div className="absolute inset-0 flex flex-col items-center justify-center p-8 text-center opacity-0 scale-110 transition-all duration-300 group-hover:opacity-100 group-hover:scale-100 bg-dark-studio/60 backdrop-blur-sm" data-id="element-38">
                <h3 className="text-2xl font-bold text-white mb-4" data-id="element-39">
                  {course.title}
                </h3>
                <p className="text-white/90 mb-6 font-medium leading-relaxed" data-id="element-40">
                  {course.description}
                </p>
                <button className="bg-white text-dark-studio px-6 py-2 rounded-full font-bold hover:bg-peony-100 transition-colors shadow-lg" data-id="element-41">
                  Jetzt buchen
                </button>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}